import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface BadgeProps {
  /**
   * UI Tur 2 §5 (StatusBadge — aynı bileşen, `tone` prop'u genişledi, yeniden ADLANDIRMA
   * yok): `info` ve `violet` YENİ. Tasarımda durum rozetlerinin hepsi "iyi/kötü" değil:
   * "İncelemede" `info`, "Revizyon" ve "Müzakere" `violet` — nötr ama dikkat çeken durumlar.
   * Bunları `warning` ile göstermek kullanıcıya olmayan bir sorun bildirirdi, `neutral`
   * ile göstermek ise onları arka plana iterdi. Sözleşme durumu → ton eşlemesi TEK yerde:
   * `apps/web/src/lib/contractStatusTone.ts` — burada uydurulmaz.
   */
  tone?: "neutral" | "success" | "warning" | "danger" | "info" | "violet" | "primary";
  children: ReactNode;
  className?: string;
}

/**
 * ⚠ Zeminler `/10` saydamlığı değil KENDİ TOKEN'ları.
 *
 * `bg-success/10` rozetin altındaki her şeyi içeri sızdırıyordu: tablo satırının hover
 * rengi değişince rozetin zemini de değişiyor, aynı rozet iki satırda iki farklı renkte
 * görünüyordu. Pastel zeminler artık opak.
 */
const toneClasses: Record<NonNullable<BadgeProps["tone"]>, string> = {
  neutral: "bg-neutral-soft text-fg-muted",
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
  info: "bg-info-soft text-info",
  violet: "bg-violet-soft text-violet",
  primary: "bg-primary-soft text-primary",
};

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-[3px] text-xs font-semibold whitespace-nowrap",
        toneClasses[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
